/* eslint-disable jira/filename-case */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { EpicsLiteResource } from './__generated_apollo__/EpicsLiteResource.ts';

export const epicsLiteResource: RouteResource<EpicsLiteResource> = createResource({
	type: 'EPICS_LITE_PRELOAD',
	getKey: ({ match }) => match.params.boardId || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-epics-lite", jiraSpaEntry: "async-epics-lite" */ './getData.tsx'
		),
	maxAge: 0,
});
